/* eslint-disable */
import chttp from '@/libs/base/coupon_http'
import apis from '@/libs/base/apis'
import weixin from '@/libs/app/weixin'
import Vue from 'vue'
import { format } from 'date-fns'
import cookie from '@/libs/utils/cookie';

const payPanel = {
  state: {
    balance: 0, // 账户余额
    show_pay_panel: false, // 支付弹窗
    parentParams: {},
    order_id: '', // 订单
  },
  mutations: {
    SHOW_PAY_PANEL (state, data) {
      if (cookie.getCookie('isSupportInteract') == 1) {
        Vue.$toast('暂不支持该功能')
        return
      }
      state.show_pay_panel = true
    },
    CLOSE_PAY_PANEL (state) {
      state.show_pay_panel = false
    },
    SAVE_PARENT_PARAMS (state, data) {
      state.parentParams = data
    },
    SAVE_VIP_BALANCE (state, balance) {
      state.balance = balance
    },
    SAVE_MAX_FEE (state, maxFee) {
      state.max_fee = maxFee
    },
    SAVE_ORDER_ID (state, orderId) {
      state.order_id = orderId
    },
  },
  actions: {
    /*
    获取账户余额信息
    */
    getBalance ({ state, commit, rootState }, closeLoading) {
      const params = {
        openid: rootState.openid,
        unionid: rootState.unionid
      }
      const url = closeLoading ? apis.balance + '?close_loading=true' : apis.balance
      chttp.get(url, { params: params })
        .then(res => {
          commit('SAVE_VIP_BALANCE', res.balance || 0)
          commit('SAVE_ZF_NUM', res.zf_num || 0)
          commit('SAVE_GM_NUM', res.gm_num || 0)
          commit('SAVE_LW_NUM', res.lw_num || 0)
          commit('SAVE_ZP_NUM', res.zp_num || 0)
          commit('SAVE_MAX_FEE', (res.right_max_fee || 0) / 100)
        })
    },
    /*
    余额支付
    */
    balancePay ({ state, commit, dispatch }, data) {
      chttp.post(data.cpUrl, data.params)
        .then(res => {
          if (res.errcode === 200) {
            // this.closePanel()
            commit('CLOSE_PAY_PANEL')
            if (state.isMinProgram) {
              weixin.navigateToMiniProgram('', '/pages/interact/interact')
              return
            }
            data.elseData.callback && data.elseData.callback(res)
            if (!data.elseData.callback) {
              Vue.$toast('支付成功')
            }
          } else {
            dispatch('getBalance')
            Vue.$toast('支付失败')
          }
        }).catch(err => {
          console.log(err)
          Vue.$toast('支付失败')
          this.loading = false
        })
    },
    // 微信支付
    wxpay ({ state, commit, dispatch }, data) {
      weixin.wxPay(data.params, data.wxUrl, data.elseData, data.type)
    },
    nationalQueryOrder ({ state, commit, dispatch, rootState }, url) {
      const params = {
        openid: rootState.openid,
        unionid: rootState.unionid
      }
      // 会员支付查单接口
      chttp.get(url, { params })
        .then(res => {
          if (res.errcode === 200) {
            commit('CLOSE_PAY_PANEL')
          } else {
            setTimeout(() => {
              dispatch('nationalQueryOrder', url)
            }, 4000)
          }
        })
    },
    sendPubInfo ({ state, commit, dispatch, rootState }, data) {
      const chatTime = new Date()
      data.time = format(chatTime, 'MM/dd HH:mm');
      chttp.post(process.env.VUE_APP_CHAT_URL + '/pub?roomid=' + rootState.roomid, data, { headers: { 'Content-Type': 'application/json' } }).then(res => {
        setTimeout(() => {
          location.href = process.env.BASE_URL + 'bar/room?roomid=' + rootState.roomid
        }, 500)
      })
    }
  }
}

export default payPanel
